import AdminChecklists from "./AdminChecklists";

export default AdminChecklists;
